/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { HeadingDesc, SectionHeadingMed } from '../../Headings';
import { SimpleAncer } from '../../button';
import google from '../../../assets/images/png/google.png';
import facebook from '../../../assets/images/svg/facebook.svg';
import closeIcon from '../../../assets/images/svg/modal-close.svg';
import phone from '../../../assets/images/png/phone.png';
import './userContinueModal.css';

function UserContinueModal(props) {
  const { show, close } = props;

  return (
    <Modal
      show={show}
      className="modalLayout userContinueModal"
      onHide={close}
      centered
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Body>
        <div className="content">
          <button type="button" className="modalCloseBtn" onClick={close}>
            <img src={closeIcon} alt="closeIcon" />
          </button>
          <SectionHeadingMed text="Tell us a bit about you." />
          <HeadingDesc text="To book your appointment, we need to verify a few things for Dr. Chagoury-Leake’s office." />
          <HeadingDesc text="Please select one of the options to continue." />
          <div className="btns_container">
            <SimpleAncer to="/reviewAndPay" text="continue with google">
              <div>
                <img src={google} alt="google" />
              </div>
            </SimpleAncer>
            <SimpleAncer to="/reviewAndPay" text="continue with facebook">
              <div>
                <img src={facebook} alt="facebook" />
              </div>
            </SimpleAncer>
            <SimpleAncer to="/reviewAndPay" text="continue with phone number">
              <div>
                <img src={phone} alt="phone" />
              </div>
            </SimpleAncer>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UserContinueModal;
